import type { ValueOf } from '@mathflat/shared/@types/utilityTypes'

import type { WorkbookDomain } from '~/@entities/(Content)/Workbook/domain'
import type { Entity as WorkbookEntity } from '~/@entities/(Content)/Workbook/dto'
import { CoverData } from '~/@entities/DesignTemplate/CoverData/dto'
import type { PODApi as PODMallCartItemApi } from '~/@entities/PODMall/CartItem/api'
import type { PrintDocumentCoverDataT } from '~/@entities/PrintDocument/type'

import type { PodPaymentPayerType } from '../Payment/type'
import type { PdfType, PrintType, ProductType } from '../Product/type'

export namespace Entity {
  export class CartItem {
    id: number
    productId: number
    customSignatureWorkbookId?: WorkbookEntity.CustomSignatureWorkbook['id']
    customWorkbookId?: WorkbookEntity.Workbook['id']

    paymentPayerType: PodPaymentPayerType
    showPrice: boolean
    signatureType: ValueOf<typeof WorkbookDomain.SIGNATURE_TYPE>
    quantity: number
    minQuantity: number
    productType: Exclude<ProductType, 'KMM_AWARDS'>
    pdfType: PdfType
    printType: PrintType

    workbookParts?: {
      title: string
      sideTitle: string
      pageCount: number
    }[]
    studentNames: string[]
    parentOrders:
      | {
          studentId: string
          parentPhoneNumber: string
          studentName: string
          printingUserName: string
        }[]
      | null

    autoScored: boolean
    name: string
    pairFlag: boolean
    pageCount: number
    problemPageCount: number
    problemAnswerPageCount: number
    price: number
    additionalPrice: number | null
    thumbnailImageUrl: string
    coverData:
      | WorkbookEntity.CustomSignatureWorkbook['coverData']
      | WorkbookEntity.CustomWorkbook['coverData']
      | CoverData<PrintDocumentCoverDataT>
      | null = null
    innerPdfUrl: string
    discountAmount: number
    productDiscountRate: number
    discountedPrice: number // 지워질 예정인지 확인
    productAmount: number

    grade: WorkbookEntity.Workbook['grade']
    semester: WorkbookEntity.Workbook['semester']
    revision: WorkbookEntity.Workbook['revision']
    schoolType: WorkbookEntity.Workbook['schoolType']

    constructor(props: CartItem | PODMallCartItemApi.Response.CartItems['cartItems'][number]) {
      this.id = props.id
      this.productId = props.productId
      this.customSignatureWorkbookId = props.customSignatureWorkbookId

      this.paymentPayerType = props.paymentPayerType
      this.signatureType = props.signatureType
      this.quantity = props.quantity
      this.minQuantity = props.minQuantity
      this.productType = props.productType
      this.pdfType = props.pdfType
      this.printType = props.printType

      this.workbookParts = props.workbookParts
      this.studentNames = props.studentNames
      this.parentOrders = props.parentOrders

      this.autoScored = props.autoScored
      this.showPrice = props.showPrice
      this.name = props.name
      this.pairFlag = props.pairFlag
      this.pageCount = props.pageCount
      this.problemPageCount = props.problemPageCount
      this.problemAnswerPageCount = props.problemAnswerPageCount
      this.price = props.price
      this.additionalPrice = props.additionalPrice
      this.discountAmount = props.discountAmount
      this.thumbnailImageUrl = props.thumbnailImageUrl
      this.productId = props.productId
      this.customSignatureWorkbookId = props.customSignatureWorkbookId
      this.customWorkbookId = props.customWorkbookId
      this.productDiscountRate = props.productDiscountRate
      this.discountedPrice = props.discountedPrice
      this.productAmount = props.productAmount
      if (props.coverData) {
        this.coverData = new CoverData<
          | WorkbookEntity.CustomSignatureWorkbookCoverDataT
          | WorkbookEntity.CustomWorkbookCoverDataT
          | PrintDocumentCoverDataT
        >(props.coverData)
      }

      this.innerPdfUrl = props.innerPdfUrl

      this.grade = props.grade
      this.semester = props.semester
      this.revision = props.revision
      this.schoolType = props.schoolType
    }
  }
}
